module.exports = __webpack_public_path__ + "static/service-2-f0a1cdf35cadbb478915715f01526ea7.jpeg";